export const RES_LOGO =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
export const RATING_STAR =
  "https://ucarecdn.com/a5921077-2612-4458-b16e-c37a80402d5a/-/preview/999x952/";
export const MENU_API =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.4089123&lng=77.3177894&restaurantId=";
export const RES_DATA =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.4089123&lng=77.3177894";
export const VEG_SIGN = "https://img.icons8.com/fluency/96/vegetarian-food-symbol.png";
export const NONVEG_SIGN =
  "https://www.pngkey.com/png/detail/245-2459071_non-veg-icon-non-veg-symbol-png.png";
export const lightTheme =
  "https://ucarecdn.com/3e2bf550-142d-4d38-9d87-9b10260a9878/2682848_day_forecast_sun_sunny_weather_icon.png";
export const darkTheme =
  "https://ucarecdn.com/481c8102-6fa2-4cbe-8f2a-5a3e2123ca37/8726101_moon_icon.png";
/* 
    fetch('https://proxy.cors.sh/https://acme.com', {
  headers: {
  'x-cors-api-key': 'temp_1d89d97e9a7fea79a5794d20f4d66a87'
  }
})
    */
